/** A thrown error's message, or `fallback` when it has none to show. */
export const errorMessage = (failure: unknown, fallback: string): string =>
	failure instanceof Error && failure.message ? failure.message : fallback;
